// src/services/authService.js
import axios from 'axios';

// const API_URL = 'https://api2.pranaamhospitals.com/api/';
// const API_Domain_URL = 'https://api2.pranaamhospitals.com/';
const API_URL = 'https://api.pranaam365.com/api/';
const API_Domain_URL = 'https://api.pranaam365.com/';

localStorage.setItem('API_URL', API_URL);
localStorage.setItem('API_Domain_URL', API_Domain_URL);

// const login = async (email, password) => {
//   const response = await axios.post(API_URL + 'login', {
//     email,
//     password,
//   });

//   const data = response.data.data;

//   if (data) {
//     // Save the user information in sessionStorage
//     sessionStorage.setItem('admininfo', JSON.stringify(data));

//     // If the role_id is not 2, store the adminOrganizationId in localStorage
//     if (data.UserInfo.role_id !== 2) {
//       localStorage.setItem('adminOrganizationId', data.UserInfo.organization_id);
//     }
//     // Optionally, store the token in sessionStorage or localStorage
//     sessionStorage.setItem('admintoken', data.token);
//   }

//   return data;
// };

const login = async (phone, otp) => {
  const response = await axios.post(API_URL + 'login', {
    phone,
    otp,
  });

  const data = response.data.data;

  if (data) {
    // Save the user information in sessionStorage
    localStorage.setItem('admininfo', JSON.stringify(data));

    // If the role_id is not 2, store the adminOrganizationId in localStorage
    if (data.UserInfo.role_id !== 2) {
      localStorage.setItem('adminOrganizationId', data.UserInfo.organization_id);
    }
    // Optionally, store the token in sessionStorage or localStorage
    localStorage.setItem('admintoken', data.token);
  }

  return data;
};


const logout = () => {
  //sessionStorage.removeItem('user');
  localStorage.removeItem('admininfo');
  localStorage.removeItem('adminOrganizationId');
};

const getCurrentadmin = () => {
  return JSON.parse(localStorage.getItem('admininfo'));
};

const getCurrentadmintoken = () => {
  return JSON.parse(localStorage.getItem('admintoken'));
};

const setAdminorganizationID = (organization) => {
  localStorage.setItem('adminOrganizationId', organization);
};

const getAdminOrganizationID = () => {
  return localStorage.getItem('adminOrganizationId');
};

// Updated getApiUrl function to use sessionStorage
const getApiUrl = () => {
  return localStorage.getItem('API_URL');
};

const getApiDomainUrl = () => {
  return localStorage.getItem('API_Domain_URL');
};

// const getApiImageUrl = () => {
//   return localStorage.getItem('API_IMAGE_URL');
// };

// const getCartApiUrl = () => {
//   return localStorage.getItem('Cart_API_URL');
// };


// client login
const Userlogin = async (phone, otp) => {
  try {
    const response = await axios.post(API_URL + 'verify-otp', {
      phone,
      otp,
    });
    const data = response.data.data;
    if (data) {
      localStorage.setItem('userInfo', JSON.stringify(data));
      localStorage.setItem('usertoken', response.data.token);
      return data; // Return the data if it exists
    }
  } catch (error) {
    console.error('API error:', error);
    throw new Error('Failed to verify OTP');
  }

  return null; // Return null if no data or an issue occurred
};

// const getCurrentUsertoken = () => {
//   return JSON.parse(sessionStorage.getItem('usertoken'));
// };

const getCurrentUsertoken = () => {
  return localStorage.getItem('usertoken');
};

const AppointmentSlotsSetup = async (date, time) => {

  localStorage.setItem('slotdate', date);
  localStorage.setItem('slottime', time);
  return date+time; // Return null if no data or an issue occurred
};

const getAppointmentSlots = () => {
  const date = localStorage.getItem('slotdate');
  let time = localStorage.getItem('slottime');

  if (!date || !time) return 'Select Date&Time';

  try {
    const parsedDate = new Date(date);
    if (isNaN(parsedDate)) throw new Error("Invalid date");

    const formattedDate = parsedDate.toLocaleDateString('en-US', {
      weekday: 'long',
      month: 'short',
      day: '2-digit',
      year: 'numeric',
    });

    // Remove any accidental quotes from the time string
    time = time.replace(/^"(.*)"$/, '$1');

    return `${formattedDate} | ${time}`;
  } catch (err) {
    console.error('Invalid date format:', err);
    return 'Invalid Date';
  }
};



const getSlots = () => {
 
  const date = localStorage.getItem('slotdate') || null;
  const time = localStorage.getItem('slottime') || null;
 
  // Return an object with the required format
  return {
    'date': date,
    'time': time,
  };
};

const RemoveSlots = () => {
  localStorage.removeItem('slotdate');
  localStorage.removeItem('slottime');
};


const getCurrentuser = () => {
  return JSON.parse(localStorage.getItem('userInfo'));
};

// const getLoggedinuser = () => {
//   return JSON.parse(localStorage.getItem('userInfo'));
// };

const clientlogout = () => {
  localStorage.removeItem('userInfo');
  localStorage.removeItem('usertoken');
};

const authService =  {
  login,
  logout,
  getCurrentadmin,
  getCurrentadmintoken,
  // getCurrentUser,
  setAdminorganizationID,
  getAdminOrganizationID,
  getApiUrl,
  getApiDomainUrl,
  getAppointmentSlots,
  // getApiImageUrl,
  // getCartApiUrl,
  Userlogin,
  getCurrentuser,
  // getLoggedinuser,
  clientlogout,
  AppointmentSlotsSetup,
  getCurrentUsertoken,
  getSlots,
  RemoveSlots,
};

export default authService;